import React from 'react'
import MyProfileOverview from '../Components/Myprofile/MyProfileOverview'

const Myprofile = () => {
  return (
    <div>
     {/* billing form */}
        <MyProfileOverview/>
    </div>
  )
}

export default Myprofile
